/**
 * videoFocus — "видео только говорящих" (2026-06-12, big-call request).
 *
 * With the toggle ON the client UNSUBSCRIBES (SFU-level, via the same
 * peerVideoHidden pipeline in VoiceManager) from the camera of every
 * participant who hasn't spoken recently. Receive bandwidth and decode
 * CPU then scale with the number of ACTIVE SPEAKERS instead of the room
 * size — the 27-person-call ask: "видео показывались только у тех, кто
 * говорит". Screen share is never touched (it goes through a different
 * Track.Source and the hidden-video pipeline already exempts it).
 *
 * Speech comes from LiveKit's ActiveSpeakersChanged. The sticky window
 * keeps a recent speaker's tile alive through natural pauses and turn
 * taking, so video doesn't flicker on every sentence boundary.
 */

export const SPEAKER_STICKY_MS = 6_000

export class SpeakerStickiness {
  private lastSpokeAt = new Map<string, number>()

  update(activeIdentities: string[], now: number): void {
    for (const id of activeIdentities) this.lastSpokeAt.set(id, now)
  }

  isRecentSpeaker(identity: string, now: number): boolean {
    const t = this.lastSpokeAt.get(identity)
    return t !== undefined && now - t <= SPEAKER_STICKY_MS
  }

  /** Drop long-stale entries so the map doesn't grow with room churn. */
  prune(now: number): void {
    for (const [id, t] of this.lastSpokeAt) {
      if (now - t > SPEAKER_STICKY_MS * 10) this.lastSpokeAt.delete(id)
    }
  }

  clear(): void {
    this.lastSpokeAt.clear()
  }
}

export function readVideoSpeakersOnly(): boolean {
  if (typeof window === 'undefined') return false
  return localStorage.getItem('videoSpeakersOnly') === 'true'
}
